import { render } from "./ProjectsSite.vue?vue&type=template&id=31a64786"
import script from "./ProjectsSite.vue?vue&type=script&lang=js"
export * from "./ProjectsSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__